import React, { useState, useEffect } from 'react';
import { Layout, Spin } from 'antd';
import { WhatsAppOutlined } from '@ant-design/icons';
import api from '../../../configs/api';

import HeaderSection from './HeaderSection';
import CoverSection from './CoverSection';
import WelcomeSection from './WelcomeCardsSection';
import LocationAndTVSection from './LocationAndTVSection';
import DiretoriaCarousel from './DiretoriaSection';
import InstagramGaleria from './InstagramGaleria';
import FooterSection from './FooterSection';

import './css/ChurchHomepage.css';

const { Content } = Layout;

const ChurchHomepage = () => {
  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHome = async () => {
      try {
        console.log('[HomePage] Iniciando busca de dados da API...');
        setLoading(true);
        const response = await api.get('/api/home');
        console.log('[HomePage] Resposta da API recebida:', response.data);
        console.log('[HomePage] youtubeVideoId recebido:', response.data?.youtubeVideoId);
        console.log('[HomePage] youtubeChannelId recebido:', response.data?.youtubeChannelId);
        console.log('[HomePage] coverSection.imagem:', response.data?.coverSection?.imagem);
        setHomeData(response.data);
      } catch (error) {
        console.error('[HomePage] Erro ao buscar dados da home:', error);
        // Fallback para dados padrão
        setHomeData({
          coverSection: {
            imagem: '/images/logo/14.png',
            texto: 'Seja bem-vindo ao site da ADCN',
            videoId: ''
          },
          welcomeSection: {
            titulo: 'UMA IGREJA PARA VOCÊ',
            subtitulo: 'Domingos às 19h | Sede ADCN - Caldas Novas, GO',
            cards: []
          },
          locationSection: {
            titulo: 'TRANSMISSÃO & LOCALIZAÇÃO',
            tvTitulo: 'Assista à TV ADCN',
            tvTexto: 'Acompanhe nossos cultos e transmissões ao vivo no canal oficial da ADCN no YouTube.',
            instagramLink: '',
            facebookLink: ''
          },
          youtubeVideoId: ''
        });
      } finally {
        setLoading(false);
      }
    };

    fetchHome();
  }, []);

  if (loading) {
    return (
      <Layout className="layout">
        <HeaderSection />
        <Content className="content-wrapper" style={{ padding: '60px 20px', textAlign: 'center' }}>
          <Spin size="large" />
        </Content>
        <FooterSection />
      </Layout>
    );
  }

  return (
    <Layout className="layout">
      {/* HEADER e CAPA */}
      <HeaderSection />
      <CoverSection 
        data={homeData?.coverSection} 
        youtubeVideoId={homeData?.youtubeVideoId || homeData?.coverSection?.videoId}
        key={`cover-${homeData?.coverSection?.imagem || 'default'}`}
      />
  
      {/* SEÇÕES GERAIS */}
      <WelcomeSection 
        data={homeData?.welcomeSection}
        key={`welcome-${homeData?.welcomeSection?.cards?.map(c => c.imagem).join('-') || 'default'}`}
      />
      <Content className="content-wrapper">
        <div className="page-container">
          {homeData?.usarInstagramGaleria && (
            <InstagramGaleria instagramLink={homeData?.instagramLink} />
          )}
          {/* Outras seções futuras aqui */}
        </div>
      </Content>
      <LocationAndTVSection data={homeData?.locationSection} youtubeVideoId={homeData?.youtubeVideoId} key={homeData?.youtubeVideoId} />
      <DiretoriaCarousel />

      {/* CONTEÚDO CENTRALIZADO */}
      

      {/* RODAPÉ */}
      <FooterSection />

      {/* WHATSAPP FLUTUANTE */}
      <div className="whatsapp-container">
        <a
          href="https://wa.me/5564999242002"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppOutlined className="whatsapp-icon" />
        </a>
      </div>
    </Layout>
  );
};

export default ChurchHomepage;
